import { useEffect, useState, useRef } from "react";
import arrowLeft from "../../../Assets/icon/arrow-narrow-left.svg";
import { useNavigate } from "react-router-dom";
import { useHeader } from "../../../Providers/HeaderContextProvider";
import arrowRight from "../../../Assets/images/arrow-right.svg";
import { checkOTP } from "../../../Services/settingsServices";
import { resendOTP } from "../../../Services/settingsServices";
import "../../../Pages/TermsofUse/style.css";



import "./style.css";
function MobilePhoneSettingsScreen3() {
  const navigate = useNavigate();
  const { setHeaderContent } = useHeader();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    setHeaderContent(false);
  }, []);


  const length = 6;
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const inputRefs = useRef([]);

  const handleChange = (value, index) => {
    // Allow digits and alphabets (both uppercase and lowercase)
    if (/^[A-Za-z0-9]$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to the next input field if valid and the input is not empty
      if (value && index < length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData
      .getData("text")
      .split("")
      .slice(0, length);
    const newOtp = [...otp];

    pasteData.forEach((char, i) => {
      if (/^[A-Za-z0-9]$/.test(char)) {
        newOtp[i] = char;
      }
    });

    setOtp(newOtp);

    // Automatically focus the last field
    inputRefs.current[pasteData.length - 1]?.focus();
  };

  const handleKeyDown = (e, index) => {
    const key = e.key;
    // Allow user to overwrite current char with new alphanumeric key directly
    if (/^[A-Za-z0-9]$/.test(key)) {
      e.preventDefault();
      const newOtp = [...otp];
      newOtp[index] = key;
      setOtp(newOtp);
      if (index < length - 1) {
        inputRefs.current[index + 1]?.focus();
      }
      return;
    }

    if (key === "Backspace") {
      e.preventDefault();
      const newOtp = [...otp];
      if (newOtp[index]) {
        // Clear current and stay
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        // Move focus to previous and clear it
        inputRefs.current[index - 1]?.focus();
        newOtp[index - 1] = "";
        setOtp(newOtp);
      }
      return;
    }
  };

  const onVerifyOtpClick = async () => {
    // Prevent accidental trigger with incomplete OTP
    const code = otp.join("");
    if (code.length < length) {
      setErrorMessage("Please enter the 6-digit code.");
      return;
    }
    console.log("[PhoneVerify] Continue clicked with code:", code);
    setIsLoading(true);
    const countryCode = sessionStorage.getItem("newcountryCode");
    const contact = sessionStorage.getItem("newContact");
    try {
      setErrorMessage("");
      const otpString = String(code); // ensure OTP sent as string
      console.log("[PhoneVerify] Calling checkOTP", { contact, countryCode, otpString });
      const response = await checkOTP({
        contact: contact,
        country_code: countryCode,
        otp: otpString,
      });
      console.log("[PhoneVerify] checkOTP response:", response);
      const payload = response?.payload;
      if (payload?.success) {
        navigate("/settings/phone/1");
        localStorage.setItem("isContactUpdated", "true");
        sessionStorage.removeItem("newContact");
        sessionStorage.removeItem("newcountryCode");
      } else {
        // Handle known error format { message: string, status: 422 }
        if (response?.status === 422) {
          setErrorMessage(response?.message || response?.mesage || "Invalid code. Please try again.");
        } else if (response?.message || response?.mesage) {
          setErrorMessage(response.message || response.mesage);
        } else {
          setErrorMessage("Verification failed. Please try again.");
        }
      }
    } catch (error) {
      console.error("[PhoneVerify] checkOTP error:", error);
      const apiMessage = error?.response?.data?.message || error?.response?.data?.mesage || error?.message;
      const apiStatus = error?.response?.status || error?.response?.data?.status;
      if (apiStatus === 422) {
        setErrorMessage(apiMessage || "Invalid code. Please try again.");
      } else if (apiMessage) {
        setErrorMessage(apiMessage);
      } else {
        setErrorMessage("Something went wrong. Please try again.");
      }
    } finally {
      console.log("[PhoneVerify] Resetting loading state");
      setIsLoading(false);
    }
  };

  const onResendOTP = async (e) => {
    e.preventDefault();
    setIsLoading1(true);
    const countryCode = sessionStorage.getItem("newcountryCode");
    const contact = sessionStorage.getItem("newContact");
    try {
      const response = await resendOTP({
        country_code: countryCode,
        contact: contact,
      });
      if (response.status === "success") {
        // Optionally, clear previous error
        setErrorMessage("");
      } else if (response?.status === 422) {
        setErrorMessage(response?.message || response?.mesage || "Unable to resend code. Please try again later.");
      }
    } catch (error) {
      console.error("Error:", error);
      const apiMessage = error?.response?.data?.message || error?.response?.data?.mesage || error?.message;
      const apiStatus = error?.response?.status || error?.response?.data?.status;
      if (apiStatus === 422) {
        setErrorMessage(apiMessage || "Unable to resend code. Please try again later.");
      } else if (apiMessage) {
        setErrorMessage(apiMessage);
      } else {
        setErrorMessage("Unable to resend code. Please try again later.");
      }
    } finally {
      setIsLoading1(false);
    }
  };

  return (
    <div>
      {" "}
      
      <header className="termsofuse-header">
        <div className="termsofuse-gradient-background">
          <div className="termsofuse-nav-container">
            <div
              className="termsofuse-logo-container"
              onClick={() => navigate(-1)}
            >
              <img
                src={arrowLeft}
                alt="Back"
                className="termsofuse-back-button"
              />
            </div>
            <h1 className="termsofuse-title">Verify your mobile number</h1>
            <div className="termsofuse-space"></div>
            <div className="set-phone-modal-support mobile-sub-txt-set-phone">
              We sent a six-digit confirmation code to your number. It will
              expire in 30 minutes, enter it soon! Keep the window open while
              checking for your code.
            </div>
          </div>
        </div>
      </header>
      <div className="set-phone-int-cnt mt-mobile-view mobile-set-cnt">
        {/* <div className="set-phone-modal-input-container">
          <div className="set-phone-input-label">Mobile number</div>
          <div className="mobile-input-wrapper">
            <input
              type="text"
              id="mobile-number"
              className="mobile-input"
              placeholder="+1 (555) 324-3459"
            />
          </div>
        </div> */}
        <div className="otp-verifier">
          <div className="otp-container" onPaste={handlePaste}>
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                maxLength={1}
                value={digit}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                ref={(el) => (inputRefs.current[index] = el)}
                className="otp-box"
              />
            ))}
          </div>
          {errorMessage && (
            <div
              className="otp-error-message"
              style={{ color: "#d93025", textAlign: "center", marginTop: "12px" }}
            >
              {errorMessage}
            </div>
          )}
          <div className="otp-rote">
            <div className="otp-typo-cnt">
              <div className="otp-get-code">Didn’t get a code?</div>
              <div
                className="otp-resend"
                onClick={onResendOTP}
                disabled={isLoading1}
                style={{
                  cursor: isLoading1 ? "not-allowed" : "pointer",
                  opacity: isLoading1 ? "0.6" : "1",
                }}
              >
                Resend code
              </div>
            </div>
            <div
              className="otp-resend changepassword"
              onClick={() => navigate("/settings/phone/2")}
              style={{ cursor: "pointer" }}
            >
              Change mobile number
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        >
          <button
            className="set-phone-continue-button"
            onClick={onVerifyOtpClick}
            disabled={isLoading}
            type="button"
            style={{
              cursor: isLoading ? "not-allowed" : "pointer",
              opacity: isLoading ? "0.6" : "1",
            }}
          >
            {" "}
            Continue <img src={arrowRight} alt="edit" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default MobilePhoneSettingsScreen3;
